export async function receiptImage(element, reference) {
  if (!element) throw new Error('Receipt is not ready');
  await document.fonts.ready;
  await Promise.all(Array.from(element.querySelectorAll('img')).map(image => image.decode().catch(() => undefined)));
  const { default: html2canvas } = await import('html2canvas');
  const canvas = await html2canvas(element, {
    scale: 2, useCORS: true, logging: false, backgroundColor: '#ffffff',
    windowWidth: 1024, scrollX: 0, scrollY: 0,
    onclone: documentCopy => {
      const receipt = documentCopy.querySelector('[data-testid="receipt-document"]');
      documentCopy.body.appendChild(receipt);
      Object.assign(receipt.style, { width: '768px', maxWidth: 'none', margin: '0', position: 'absolute', left: '0', top: '0', boxShadow: 'none' });
    },
  });
  const blob = await new Promise((resolve, reject) => canvas.toBlob(value => value ? resolve(value) : reject(new Error('Receipt image could not be created')), 'image/png'));
  const safeReference = String(reference || 'receipt').replace(/[^a-zA-Z0-9_-]/g, '_');
  return new File([blob], `MALDHOWR-receipt-${safeReference}.png`, { type: 'image/png' });
}

export function downloadReceipt(file) {
  const url = URL.createObjectURL(file);
  const link = document.createElement('a');
  link.href = url; link.download = file.name;
  document.body.appendChild(link); link.click(); link.remove();
  setTimeout(() => URL.revokeObjectURL(url), 1000);
}